import { render, staticRenderFns } from "./Resultslist.vue?vue&type=template&id=52c38996&scoped=true"
import script from "./Resultslist.vue?vue&type=script&lang=js"
export * from "./Resultslist.vue?vue&type=script&lang=js"
import style0 from "./Resultslist.vue?vue&type=style&index=0&id=52c38996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c38996",
  null
  
)

export default component.exports